export const PROTOCOL_FOODS = {
  prefer: {
    it: ["Pesce azzurro (sgombro, sardine, salmone)", "Olio extravergine d'oliva", "Verdure a foglia verde", "Frutti di bosco e frutta fresca", "Frutta secca e semi", "Legumi", "Cereali integrali", "Curcuma e zenzero", "Tè verde", "Aglio e cipolla"],
    en: ["Oily fish (mackerel, sardines, salmon)", "Extra-virgin olive oil", "Leafy green vegetables", "Berries and fresh fruit", "Nuts and seeds", "Legumes", "Whole grains", "Turmeric and ginger", "Green tea", "Garlic and onion"],
  },
  avoid: {
    it: ["Zuccheri raffinati e dolci", "Bevande zuccherate", "Cibi ultra-processati", "Fritti", "Carni lavorate (salumi, insaccati)", "Eccesso di carni rosse", "Alcol", "Farine e oli raffinati"],
    en: ["Refined sugars and sweets", "Sugary drinks", "Ultra-processed foods", "Fried foods", "Processed meats (cold cuts)", "Excess red meat", "Alcohol", "Refined flours and oils"],
  },
};
